import { handleActions } from 'redux-actions'

export const defaultState = {
  selectedRetailerId: null,
  retailerSearchText: '',
}

const reducer = handleActions(
  {
    'APPOINTMENT_FORM_MODAL/SET_SELECTED_RETAILER_ID': (
      state,
      { payload },
    ) => ({
      ...state,
      selectedRetailerId: payload,
    }),
    'APPOINTMENT_FORM_MODAL/CHANGE_RETAILER_SEARCH_TEXT': (
      state,
      { payload },
    ) => ({
      ...state,
      retailerSearchText: payload,
    }),
  },
  defaultState,
)

export default reducer
